import { operations, paths } from "./generated-types";
import createClient from "openapi-fetch";
import {
  requestIdMiddleware,
  sessionTokenMiddleware,
} from "@wiesinghilker/extension-lib-frontend";

const client = createClient<paths>({
  baseUrl: import.meta.env.VITE_APP_API_BASE_URI,
  credentials: "include",
});

client.use(sessionTokenMiddleware);
client.use(requestIdMiddleware);

export const getMailAddress = (
  params: operations["mail.get"]["parameters"],
) => {
  return client.GET("/mail-addresses/{mailAddressId}", {
    params,
    signal: AbortSignal.timeout(2000),
  });
};
